import { Injectable } from '@angular/core';

declare var dataLayer;

export function traceButton(event, type: string): void {
    var target = event.target.id || event.target.parentNode.id;
    dataLayer.push({
        'event': 'traceButton', 'element': {
            'idButton': target,
            'typeButton': type
        }
    },);
}

export function traceButton2(event: Event, type: string = 'navigate'): void {
    const buttonId = (event.currentTarget as HTMLElement).id;
    dataLayer.push({
        'event': 'traceButton', 'element': {
            'idButton': buttonId,
            'typeButton': type
        }
    },);
}


@Injectable({
    providedIn: 'root',
  })
  export class ButtonTraceService { 
    constructor() {
    }
    traceButton(event: Event, type: string, experience?: string): void {
        const buttonId_source = (event.currentTarget as HTMLElement).id;
        const buttonId = experience ? `${buttonId_source}-${experience}` : buttonId_source;
        dataLayer.push({
            'event': 'traceButton', 'element': {
                'idButton': buttonId,
                'typeButton': type
            }
        });
    }
  }